import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { TGetRateUsData } from "../../../Types";
import {
  isDefinedArray,
  isNullOrUndefined,
  isPositiveNumber
} from "et3-type-guards";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallGetRatingUsData } from "../../../api/auditor-api/api-call-get-rating-us-data";
import getCorePopUpStore from "../../core/core-popup-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class UserRateUsStore {
  // Observables
  rateUsLimit = observable.box<TEt3PickerSingleValue>({
    label: "50 days",
    value: "50"
  });
  rateUsData = observable.box<TGetRateUsData>([]);

  setRateUsLimit = (value: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.rateUsLimit.set(value);
    });
  };

  getRatingsData = async () => {
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.rateUsLimit.get().value, 10)
    );
    if (!isPositiveNumber(definedLimit)) {
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_USER_RATE_US_DATA", true);
    const { data, status, code } = await apiCallGetRatingUsData(definedLimit);
    getCoreUIStore().setIsLoading("AUDITOR_USER_RATE_US_DATA", false);
    if (status === "OK") {
      if (!isNullOrUndefined(data) && isDefinedArray(data)) {
        this.rateUsData.set(data);
      } else {
        this.rateUsData.set([]);
        getCorePopUpStore().showAlertMessage("USER_RATE_US_DATA_NOT_FOUND");
      }
    } else {
      this.rateUsData.set([]);
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getUserRateUsStore = memoize(
  () => new UserRateUsStore(),
  () => 1
);

export default getUserRateUsStore;
